module.exports = __webpack_public_path__ + "media/images/no_image-47f0cd8a59a46e2099a92945f074f310.jpg";